import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../components';
import Carriers from './settings/Carriers';
import AddCarrier from './settings/carriers/AddCarrier';
import EditCarrier from './settings/carriers/EditCarrier';
import ViewCarrier from './settings/carriers/ViewCarrier';
import Clients from './settings/Clients';
import AddClient from './settings/clients/AddClient';
import ViewClient from './settings/clients/ViewClient';
import Redesign from './settings/Redesign';
import Resize from './settings/Resize';
import SupportedLanguage from './settings/SupportedLanguage';


const propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function SettingsClientRouter({ match }) {
  return (
    <Switch>
      <PrivateRoute exact path={`${match.path}/carriers`} component={Carriers} />
      <PrivateRoute exact path={`${match.path}/carriers/new`} component={AddCarrier} />
      <PrivateRoute exact path={`${match.path}/carriers/:carrierId`} component={ViewCarrier} />
      <PrivateRoute exact path={`${match.path}/carriers/:carrierId/edit`} component={EditCarrier} />
      <PrivateRoute exact path={`${match.path}/clients`} component={Clients} />
      <PrivateRoute exact path={`${match.path}/clients/new`} component={AddClient} />
      <PrivateRoute exact path={`${match.path}/clients/:clientId`} component={ViewClient} />
      <PrivateRoute exact path={`${match.path}/redesign`} component={Redesign} />
      <PrivateRoute exact path={`${match.path}/resize`} component={Resize} />
      <PrivateRoute exact path={`${match.path}/supportedLanguage`} component={SupportedLanguage} />
    </Switch>
  );
}

SettingsClientRouter.propTypes = propTypes;
export default SettingsClientRouter;
